import { useAppSelector } from "../../../hooks/redux";
import styles from "./styles.module.scss";

/**
 * Full-screen mint loading screen rendered above the active router while a
 * setup ⇄ patient transition is in progress. Driven by `auth.modeSwitching`,
 * orchestrated by the `useModeSwitch` hook, and mounted in `AppRouter` so
 * it survives the router swap that happens mid-transition.
 *
 * Returns null when no transition is active.
 */
export function ModeSwitchOverlay() {
  const switching = useAppSelector((state) => state.auth.modeSwitching);
  if (!switching) return null;

  const headline =
    switching.target === "setup" ? "Loading setup view" : "Loading member view";

  return (
    <div
      className={styles.overlay}
      role="status"
      aria-live="polite"
      aria-label={headline}
    >
      <div className={styles.iconWrap}>
        <div className={styles.spinner} aria-hidden />
      </div>
      <p className={styles.label}>One moment</p>
      <p className={styles.title}>{headline}</p>
    </div>
  );
}
